module.exports = {
	"id": "SR",
	"name": "Suriname",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.041424,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.010356,
			"19": null,
			"20": 0.005178,
			"21": null,
			"22": 0.170874,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.020712,
			"27": 0.010356,
			"28": 0.036246,
			"29": 0.005178,
			"30": null,
			"31": 0.289968,
			"32": 0.015534,
			"33": 0.010356,
			"34": 0.020712,
			"35": 0.020712,
			"36": 0.062136,
			"37": null,
			"38": 0.020712,
			"39": 0.010356,
			"40": 0.010356,
			"41": null,
			"42": 0.010356,
			"43": 0.062136,
			"44": 0.031068,
			"45": 0.046602,
			"46": 0.020712,
			"47": 0.098382,
			"48": 0.020712,
			"49": 1.051134,
			"50": 0.093204,
			"51": 0.434952,
			"52": 0.341748,
			"53": 21.46281,
			"54": 6.027192,
			"55": 0.124272,
			"56": 0.020712,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.005178,
			"10": null,
			"11": 0.005178,
			"12": 0.005178,
			"13": null,
			"14": 0.010356,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.02589,
			"34": null,
			"35": 0.005178,
			"36": 0.02589,
			"37": 0.010356,
			"38": 0.015534,
			"39": 0.041424,
			"40": 0.010356,
			"41": 0.015534,
			"42": 0.010356,
			"43": 0.036246,
			"44": 0.010356,
			"45": 0.031068,
			"46": 0.015534,
			"47": 0.445308,
			"48": 0.331392,
			"49": 4.76376,
			"50": 0.5178,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.010356,
			"28": null,
			"29": 0.093204,
			"30": 0.005178,
			"31": 0.010356,
			"32": null,
			"33": 0.108738,
			"34": 0.010356,
			"35": null,
			"36": 0.015534,
			"37": 0.31068,
			"38": null,
			"39": 0.010356,
			"40": 0.357282,
			"41": 0.113916,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.02589
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.005178,
			"6": null,
			"7": null,
			"8": 0.07767,
			"9": 0.031068,
			"10": 0.445308,
			"3.1": null,
			"3.2": null,
			"5.1": 0.015534,
			"6.1": 0.046602,
			"7.1": null,
			"9.1": 0.222654
		},
		"ios_saf": {
			"8": 0,
			"10": 3.28050340133,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0884057707119,
			"8.1-8.4": 0.163325915383,
			"9.0-9.2": 0.077916950458,
			"9.3": 1.18873296211
		},
		"android": {
			"3": 0,
			"4": 0.140103788114,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0175129735142,
			"4.1": 0.505374378553,
			"4.2-4.3": 1.26343594638,
			"4.4": 2.89714618992,
			"4.4.3-4.4.4": 2.92216472351
		},
		"ie": {
			"6": 0.010356,
			"7": 0.05178,
			"8": 0.357282,
			"9": 0.227832,
			"10": 0.23301,
			"11": 3.697092,
			"5.5": null
		},
		"op_mob": {
			"0": 0.163642564278,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00454562678549
		},
		"edge": {
			"12": 0.28479,
			"13": 0.787056,
			"14": 1.439484
		},
		"ie_mob": {
			"10": 0.0760811267606,
			"11": 0.309758873239
		},
		"bb": {
			"7": 0.41357225,
			"10": null
		},
		"samsung": {
			"0": 8.657285
		},
		"and_uc": {
			"0": 1.210573
		},
		"op_mini": {
			"0": 2.20472780894
		},
		"and_chr": {
			"0": 25.728986
		},
		"and_ff": {
			"0": 0.043407
		}
	},
	"total": 97.30677425
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SR.json
 ** module id = 650
 ** module chunks = 0
 **/